import { PlatformIcon } from "./branding";
import { InfoTip } from "./ui";

export function PageHeader({ title, subtitle, info, right }) {
  return (
    <div className="flex flex-col gap-3 sm:flex-row sm:items-start sm:justify-between sm:gap-4 mb-6">
      <div className="min-w-0">
        <div className="flex items-center gap-2">
          <h1
            className="text-[24px] sm:text-[30px] font-bold tracking-tight text-foreground"
            style={{ letterSpacing: "-0.02em" }}
          >
            {title}
          </h1>
          {info ? <InfoTip text={info} /> : null}
        </div>
        {subtitle ? <p className="text-muted text-[13.5px] sm:text-[14.5px] mt-1 max-w-2xl">{subtitle}</p> : null}
      </div>
      {right ? (
        <div className="flex gap-2 w-full sm:w-auto sm:shrink-0 [&>*]:flex-1 sm:[&>*]:flex-none">
          {right}
        </div>
      ) : null}
    </div>
  );
}

export function FilterChip({ active, onClick, label, platform }) {
  return (
    <button
      onClick={onClick}
      className={`px-3 py-1.5 rounded-full text-[12.5px] font-medium flex items-center gap-1.5 border transition active:scale-[0.97] ${
        active
          ? "bg-accent text-accent-foreground border-transparent"
          : "border-border text-muted hover:text-foreground"
      }`}
    >
      {platform ? <PlatformIcon id={platform} size={12} className={active ? "" : "text-muted"} /> : null}
      {label}
    </button>
  );
}